import React, { FunctionComponent } from "react";
import { style } from "typestyle";

interface INavBarProps {
  left?: JSX.Element | null;
  right?: JSX.Element | null;
}
const NavBar: FunctionComponent<INavBarProps> = ({
  left,
  right,
}: INavBarProps) => (
  <div
    className={style({
      height: "64px",
      backgroundColor: "#212121",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      boxSizing: "border-box",
      padding: "0px 32px",
    })}
  >
    <div
      className={style({
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        flex: 1,
      })}
    >
      {left}
    </div>
    <div
      className={style({
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        flex: 1,
        $nest: {
          "&>*": {
            marginLeft: "48px",
          },
          "&:last-child": {
            marginLeft: 0,
          },
        },
      })}
    >
      {right}
    </div>
  </div>
);

export default NavBar;
